export const KB = 1024;
export const MB = 1024 * KB;
export const GB = 1024 * MB;

export const SystemError = {
  ERROR_NONE: 0,
  ERROR_SETUP_INA: 1 << 1,
  ERROR_READ_INA: 1 << 2,
  ERROR_SETUP_LOADCEL: 1 << 3,
  ERROR_READ_LOADCEL: 1 << 4,
  ERROR_SETUP_CAN: 1 << 5,
  ERROR_READ_CAN: 1 << 6,
  ERROR_SETUP_SD: 1 << 7,
  ERROR_SETUP_SD_FILE: 1 << 8,
  ERROR_WRITE_SD_FILE: 1 << 9,
  ERROR_SYNC_SD_FILE: 1 << 10,
  ERROR_NTP_SYNC: 1 << 11,
  ERROR_INA_QUEUE_FULL: 1 << 12,
  ERROR_LOADCELL_QUEUE_FULL: 1 << 13,
  ERROR_CAN_QUEUE_FULL: 1 << 14,
  ERROR_SETUP_PRESSURE: 1 << 15,
  ERROR_READ_PRESSURE: 1 << 16,
  ERROR_SETUP_MOTOR: 1 << 17,
  ERROR_READ_MOTOR: 1 << 18,
  ERROR_SETUP_GPS: 1 << 19,
  ERROR_READ_GPS: 1 << 20,
  ERROR_FIX_GPS: 1 << 21,
  ERROR_SETUP_PIJUICE: 1 << 22,
  ERROR_READ_PIJUICE: 1 << 23,
  ERROR_SETUP_CAMERA: 1 << 24,
  ERROR_TAKE_PICTURE: 1 << 25,
  ERROR_TAKE_VIDEO: 1 << 26,
  ERROR_SEND_RS485: 1 << 27,
  ERROR_SETUP_IMU: 1 << 28,
  ERROR_READ_IMU: 1 << 29,
  ERROR_SETUP_WATERLEVEL: 1 << 30,
  ERROR_READ_WATERLEVEL: 1 << 31,
};

export const ODriveAxisState = [
  "AXIS_STATE_UNDEFINED",
  "AXIS_STATE_IDLE",
  "AXIS_STATE_STARTUP_SEQUENCE",
  "AXIS_STATE_FULL_CALIBRATION_SEQUENCE",
  "AXIS_STATE_MOTOR_CALIBRATION",
  "UNDEFINED",
  "AXIS_STATE_ENCODER_INDEX_SEARCH",
  "AXIS_STATE_ENCODER_OFFSET_CALIBRATION",
  "AXIS_STATE_CLOSED_LOOP_CONTROL",
  "AXIS_STATE_LOCKIN_SPIN",
  "AXIS_STATE_ENCODER_DIR_FIND",
  "AXIS_STATE_HOMING",
  "AXIS_STATE_ENCODER_HALL_POLARITY_CALIBRATION",
  "AXIS_STATE_ENCODER_HALL_PHASE_CALIBRATION",
];

// ODrive brake resistor state (denshi's app::kBrake* bitmask), reported per
// odrive message as brake_flags. Bit 1 says the drive latched a duty demand it
// could not deliver at some point, not that it is saturated right now.
export const ODriveBrakeFlag = {
  ARMED: 1 << 0,
  SATURATED: 1 << 1,
};

export const ODriveError = {
  ERROR_NONE: 0,
  INITIALIZING: 1,
  SYSTEM_LEVEL: 2,
  TIMING_ERROR: 4,
  MISSING_ESTIMATE: 8,
  BAD_CONFIG: 16,
  DRV_FAULT: 32,
  MISSING_INPUT: 64,
  DC_BUS_OVER_VOLTAGE: 256,
  DC_BUS_UNDER_VOLTAGE: 512,
  DC_BUS_OVER_CURRENT: 1024,
  DC_BUS_OVER_REGEN_CURRENT: 2048,
  CURRENT_LIMIT_VIOLATION: 4096,
  MOTOR_OVER_TEMP: 8192,
  INVERTER_OVER_TEMP: 16384,
  VELOCITY_LIMIT_VIOLATION: 32768,
  POSITION_LIMIT_VIOLATION: 65536,
  WATCHDOG_TIMER_EXPIRED: 16777216,
  ESTOP_REQUESTED: 33554432,
  SPINOUT_DETECTED: 67108864,
  BRAKE_RESISTOR_DISARMED: 134217728,
  THERMISTOR_DISCONNECTED: 268435456,
  CALIBRATION_ERROR: 1073741824,
};

// Dan-Tech XQ-BMS (CAN-XQBMS-01 Rev A1), message 0x11110100 bits 0-14.
// Bit 15 is the self-latch switch state, see BatterySelfLatchOpen.
export const BatteryProtection = {
  PROTECTION_NONE: 0,
  CELL_OVER_VOLTAGE: 1 << 0,
  CELL_UNDER_VOLTAGE: 1 << 1,
  PACK_OVER_VOLTAGE: 1 << 2,
  PACK_UNDER_VOLTAGE: 1 << 3,
  CHARGE_OVER_TEMPERATURE: 1 << 4,
  CHARGE_UNDER_TEMPERATURE: 1 << 5,
  DISCHARGE_OVER_TEMPERATURE: 1 << 6,
  DISCHARGE_UNDER_TEMPERATURE: 1 << 7,
  CHARGE_OVER_CURRENT: 1 << 8,
  DISCHARGE_OVER_CURRENT: 1 << 9,
  SHORT_CIRCUIT: 1 << 10,
  FRONT_END_IC_ERROR: 1 << 11,
  SOFTWARE_MOS_LOCKOUT: 1 << 12,
};

export const BatterySelfLatchOpen = 1 << 15;

// Alarm flag 1, identical bit layout for alarm levels 1, 2 and 3.
export const BatteryAlarm1 = {
  ALARM_NONE: 0,
  CELL_OVER_VOLTAGE: 1 << 0,
  CELL_UNDER_VOLTAGE: 1 << 1,
  PACK_OVER_VOLTAGE: 1 << 2,
  PACK_UNDER_VOLTAGE: 1 << 3,
  CHARGE_HIGH_TEMPERATURE: 1 << 4,
  CHARGE_LOW_TEMPERATURE: 1 << 5,
  DISCHARGE_HIGH_TEMPERATURE: 1 << 6,
  DISCHARGE_LOW_TEMPERATURE: 1 << 7,
  AMBIENT_HIGH_TEMPERATURE: 1 << 8,
  AMBIENT_LOW_TEMPERATURE: 1 << 9,
  MOS_HIGH_TEMPERATURE: 1 << 10,
  TEMPERATURE_DIFFERENTIAL: 1 << 11,
  VOLTAGE_DIFFERENTIAL: 1 << 12,
  SOC_LOW: 1 << 13,
  CHARGE_OVER_CURRENT: 1 << 14,
  DISCHARGE_OVER_CURRENT: 1 << 15,
};

// Alarm flag 2, identical bit layout for alarm levels 1, 2 and 3.
export const BatteryAlarm2 = {
  ALARM_NONE: 0,
  POSITIVE_INSULATION_RESISTANCE_LOW: 1 << 0,
  NEGATIVE_INSULATION_RESISTANCE_LOW: 1 << 1,
};

export function getActiveErrors(error_codes, code) {
  let remaining = code;
  const errors = Object.keys(error_codes).filter(key => {
    const value = error_codes[key];
    if (value !== 0 && (code & value) === value) {
      remaining &= ~value;
      return true;
    }
    return false;
  });

  if (remaining !== 0) errors.push("ERROR_UNKNOWN");

  return errors;
}

export const formatTimestamp = (timestamp) =>
  timestamp ? new Date(timestamp).toLocaleTimeString([], { hour12: false }) : "N/A";

export const formatValue = (value, decimals = 1) =>
  value !== undefined ? value?.toFixed(decimals) : "N/A";

// Seconds - denshi's status.uptime is the one that arrives - read as the two
// coarsest units that carry it, so a WEC up for weeks reads in days and hours
// and one that just rebooted in minutes and seconds. Zero is a real uptime, a
// device that has this moment come back, so it renders rather than falling to
// "N/A".
export function formatDuration(seconds) {
  if (seconds === undefined || seconds === null) return "N/A";
  const total = Math.max(0, Math.floor(seconds));
  const parts = [
    ["d", Math.floor(total / 86400)],
    ["h", Math.floor(total / 3600) % 24],
    ["m", Math.floor(total / 60) % 60],
    ["s", total % 60],
  ];
  const first = parts.findIndex(([, value]) => value > 0);
  if (first === -1) return "0s";
  return parts.slice(first, first + 2).map(([unit, value]) => `${value}${unit}`).join(" ");
}

export function scaleValue(value, from, to) {
  const scale = (to[1] - to[0]) / (from[1] - from[0]);
  const capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
  return capped * scale + to[0];
}
